import { useTimezones } from 'hb-react/shared/hooks/useTimezones';
import { getTimezoneId, getFormattedDate } from 'helpers/dateHelper';
import { getFormattedLocation } from 'helpers/locationData';

export const useInitialValues = ({ trip }) => {
  const { data: allTimezones } = useTimezones();

  const timezoneId = getTimezoneId(allTimezones, trip.timezone);
  const eventStartDate = getFormattedDate(trip.start_date);
  const eventEndDate = getFormattedDate(trip.end_date);
  // Omit location, otherwise API crash
  const { location, ...destinationTripLocation } = getFormattedLocation(trip);

  return {
    trip: {
      content: trip.content || '',
      departure_location_attributes: getFormattedLocation(
        trip.departure_location,
      ),
      end_date: eventEndDate || '',
      start_date: eventStartDate || '',
      timezone: timezoneId,
      transportation: trip.transportation || '',
      live_feed_version: 2,
      // Flat destination location
      ...destinationTripLocation,
    },
  };
};
